import React from 'react';
import { useHistory } from 'react-router-dom';
import { EyeFill, EyeSlashFill } from 'styled-icons/bootstrap';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { firebase } from '../../../system/model/firebase/firebase';
import Logo from '../../../system/access/images/logo.png';
import { companyLogin } from '../../../redux/actions/auth_actions';
import { startSetCompany } from '../../../redux/actions/platformAction';
import unisATSRoutes from "../../../system/router";
import { MainLoggin } from "../../../system/styles/pages/login";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { platform } = useSelector((state) => state);
  const [state, setState] = React.useState({
    email: '',
    password: '',
    error: null,
    typeInput: 'password',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const viewPassword = () => {
    const { typeInput } = state;
    if (typeInput === 'password') {
      setState((prev) => ({
        ...prev,
        typeInput: 'text',
      }));
    } else {
      setState((prev) => ({
        ...prev,
        typeInput: 'password',
      }));
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const { email, password } = state;
    if (email !== '' && password !== '') {
      try {
        const user = await firebase.auth().signInWithEmailAndPassword(email, password);
        if (user.user.emailVerified) {
          const idTokenResult = await firebase.auth().currentUser.getIdTokenResult();
          if (
            idTokenResult.claims.typeuser === 'company' &&
            idTokenResult?.claims?.segment?.toUpperCase() === platform?.platformName?.toUpperCase()
          ) {
            await dispatch(companyLogin(user.user.uid, 'company', user.user));
            dispatch(startSetCompany());
            history.push(unisATSRoutes.VACANCIES);
          } else {
            await firebase.auth().signOut();
            setState((prev) => ({
              ...prev,
              error: 'Este apartado esta restringido',
              message: 'Este apartado esta restringido por favor evita sanciones en la plataforma.',
              showMessage: true,
            }));
            NotificationManager(state.error, 'No tienes permisos...', 3000);
          }
        }
      } catch (error) {
        const errorCode = error.code;
        if (errorCode === 'auth/invalid-email' || errorCode === 'auth/wrong-password') {
          setState((prev) => ({
            ...prev,
            error: 'Correo o constraseña invalida',
            message: 'El correo o contraseña que ingresaste es incorrecto, por favor verifica e intenta de nuevo',
            showMessage: true,
          }));
        } else if (errorCode === 'auth/user-not-found') {
          setState((prev) => ({
            ...prev,
            error: 'No se encontro ususario',
            message:
              'No encontramos a ningun usuario registrado con este correo, solicita a la institucion que te registren a traves de la plataforma.',
            showMessage: true,
          }));
        } else if (errorCode === 'auth/too-many-requests') {
          setState((prev) => ({
            ...prev,
            error: 'Cuenta en espera',
            message:
              'Has intentado entrar con una contraseña equivocada varias veces, intentalo de nuevo más tarde o ponte en contacto con el administrador de la plataforma.',
            showMessage: true,
          }));
        } else if(error.toString().includes('TypeError')){
            setState((prev) => ({ ...prev, error:  "Error con su cuenta, revisar si esta en la plataforma correcta." }));
          }else {
            setState((prev) => ({ ...prev, error: error.toString() || "Error con su cuenta, revisar si esta en la plataforma correcta." }));
          }
        NotificationManager.error(state.error, 'Algo salio mal ...', 3000);
      }
    } else {
      NotificationManager.error('Falta rellenar los campos de correo y contraseña.');
    }
  };

  const viewIcon = (type) => {
    if (type === 'password') {
      return <EyeFill type="button" onClick={viewPassword} />;
    }
    return <EyeSlashFill type="button" onClick={viewPassword} />;
  };

  return (
    <MainLoggin>
      {/* <button */}
      {/*  type="button" */}
      {/*  className="goback" */}
      {/*  onClick={ () =>  { */}
      {/*    console.log(`${window.location?.ancestorOrigins[0]}/students`, window.location) */}
      {/*  } } */}
      {/* > */}
      {/*  Regresar */}
      {/* </button> */}
      <aside
        className="login-left"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/4065864/pexels-photo-4065864.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      />
      <div className="login-right">
        <img src={Logo} alt="" />
        <h3 className="text-center">Bienvenido de nuevo</h3>
        <p className="text-center">{state.error}</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Tu Correo Electrónico"
            name="email"
            value={state.email}
            onChange={handleInputChange}
          />
          <div className="input-password">
            <input
              type={state.typeInput}
              placeholder="Tu Contraseña"
              name="password"
              value={state.password}
              onChange={handleInputChange}
            />
            {state.password.length ? viewIcon(state.typeInput) : null}
          </div>
          <button type="submit">Login</button>
          <button type="button" className="forgot-link" onClick={() => history.push(unisATSRoutes.ForgotPass)}>
            ¿Olvidaste tu contraseña?
          </button>
        </form>
      </div>
    </MainLoggin>
  );
};
export default Login;
